import React from 'react';
import Multiselect from 'multiselect-react-dropdown';
import './MultiSelect.css'
import { useState } from 'react';
import { Link } from 'react-router-dom';






export default function MultiSelect() {
    const [selectedItem, setSelectedItem] = useState([])
    console.log("selectedItem", selectedItem);
    return (
        <div className="search-bar-donasi">
            <Link to="/search">
                <input
                    className="input-search-baru"
                    type="text"
                    placeholder="search..."
                />
            </Link>


            {/* <Multiselect
                id="css_custom"
                displayValue="key"
                groupBy="Donasi"
                onRemove={function noRefCheck() { }}
                onSelect={(a, b) => setSelectedItem([...selectedItem, b])}
                options={[
                    {
                        Donasi: 'Kategori Donasi',
                        key: 'Kemanusiaan'
                    },
                    {
                        Donasi: 'Kategori Donasi',
                        key: 'Pendidikan'
                    },
                    {
                        Donasi: 'Kategori Donasi',
                        key: 'Kesehatan'
                    },
                    {
                        Donasi: 'Kategori Donasi',
                        key: 'Anak'
                    },
                    {
                        Donasi: 'Jenis Donasi',
                        key: 'Uang'
                    },
                    {
                        Donasi: 'Jenis Donasi',
                        key: 'Pakaian'
                    },
                    {
                        Donasi: 'Jenis Donasi',
                        key: 'Makanan'
                    },
                    {
                        Donasi: 'Jenis Donasi',
                        key: 'Elektronik'
                    },
                    {
                        Donasi: 'Jenis Donasi',
                        key: 'Buku'
                    },
                    {
                        Donasi: 'Jenis Donasi',
                        key: 'Mainan Anak'
                    },
                    {
                        Donasi: 'Jenis Donasi',
                        key: 'Medis'
                    }

                ]}
                // showCheckbox
                placeholder="Cari kategori dan jenis donasi"
                style={{
                    chips: {
                        'background': '#00AF91'
                    },
                    multiselectContainer: {
                        'color': '#007965',
                        'width': '75%'
                    },
                    searchBox: {
                        'border': '1px solid #00AF91',
                        'border-radius': '5px',
                        'width': '75%',
                        'margin-left': '280px',
                        'height': '50px',
                        'display': 'flex',
                        'flex-direction': 'row',
                    },
                    optionContainer: {
                        'width': '75%',
                        'display': 'flex',
                        'flex-direction': 'column',
                        'margin-left': '280px',
                        'height': '500px'
                    },
                    groupHeading: {
                        'font-weight': 'bold',
                        'color': '#000'
                    }
                }}
                selectionLimit={2}
            /> */}


            {/* <button className="search-bar-btn">Cari</button> */}
        </div>
    )
}